export default __webpack_public_path__ + "static/bhaskar-1319c49b2f93faa5450e05467e082def.png";